export default __webpack_public_path__ + "static/media/2019-IMcover.d97e7273.png";